import styled from 'styled-components'
import { Box } from 'rebass'
import { media } from '../../../utils/style'

export const Wrapper = styled(Box)`
  width: 100%;
  padding: 32px 32px 0;
  display: flex;

  ${media.MediumScreenUp`
    padding-bottom: 32px;
  `}
`

export const WrapperInner = styled(Box)`
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`
